import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import  HTML5Backend  from 'react-dnd-html5-backend' 

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { store } from 'store'

import { Provider } from 'react-redux';

if(process.env.REACT_APP_ENV === 'PRODUCTION') { console.log = () => {} }
ReactDOM.render(<Provider store={store}>
					<BrowserRouter>
						<DndProvider backend={HTML5Backend}>
							<App/>  
						</DndProvider>
					</BrowserRouter>
				</Provider>
				, 
				document.getElementById('root'));

// ReactDOM.render(
// 	<React.StrictMode>
// 		<App />
// 	</React.StrictMode>,
// 	document.getElementById('root')
// 	);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
